module.exports = __webpack_public_path__ + "img/app-hand-top.a262d3f5.png";